export default __webpack_public_path__ + "static/media/171671__leszek-szary__success-1.4a325b66.mp3";